'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidBoat = function IoAndroidBoat(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm4.1 32.3l-4-10.9c-0.2-0.5-0.1-0.9 0.1-1.3s0.6-0.6 1-0.8l2.9-1v-7.7c0-1.8 1.6-3.3 3.4-3.3h5l1.3-4.2h7.5l1.2 4.2h5c1.8 0 3.4 1.5 3.4 3.3v7.7l2.9 1c0.4 0.2 0.9 0.4 1 0.8s0.3 0.9 0.1 1.3l-4 10.9h0c-2.7 0-5.1-1.6-6.8-3.4-1.6 1.8-3.9 3.4-6.6 3.4s-5-1.5-6.6-3.3c-1.7 1.8-4.1 3.3-6.8 3.3h0z m3.4-21.7v6.6l10-3.2 10 3.2v-6.6h-20z m16.6 21.3s4.7 5 8.4 5h-1.6c-2.4 0-4.6-1-6.8-2.1-4.1 2.2-9.1 2.2-13.2 0-2.1 1.1-4.4 2.1-6.8 2.1h-1.6c3.8 0 8.4-5 8.4-5 4 2.8 9.2 2.8 13.2 0z' })
        )
    );
};

exports.default = IoAndroidBoat;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-boat.js
// module id = 1822
// module chunks = 0